(function() {
    'use strict';
    
    const $body = document.body;
    
    // Helper to access halo functions
    function getHalo() {
        return window.halo || {};
    }
    
    const productView = {
        initProductView: function ($scope) {
            productView.productImageGallery($scope);
            productView.productLastSoldOut($scope);
            productView.productCustomerViewing($scope);
            productView.productCountdown($scope);
            productView.productSizeChart($scope);
            // productCustomCursor removed - cursor is now handled by CSS
            productView.productVideoGallery($scope);
            productView.initVariantImageGroup($scope, window.variant_image_group);
        },

        productImageGallery: function ($scope) {
            // Convert $scope from jQuery to DOM element if needed
            const scopeEl = $scope instanceof Element ? $scope : ($scope && $scope[0] ? $scope[0] : $scope);
            if (!scopeEl) return;
            
            // Use Swiper module if available
            if (typeof window.initProductImageGallery === 'function') {
                const result = window.initProductImageGallery(scopeEl);
                if (result) {
                    return result;
                }
            }
        },

        productVideoGallery: function ($scope) {
            // Convert $scope from jQuery to DOM element if needed
            const scopeEl = $scope instanceof Element ? $scope : ($scope && $scope[0] ? $scope[0] : $scope);
            if (!scopeEl) return;
            
            const videoThumbnail = scopeEl.querySelectorAll('[data-video-thumbnail]'),
                videoThumbnailLen = videoThumbnail.length,
                productVideoLen = document.querySelectorAll('.productView-video').length;

            if (videoThumbnailLen) {
                const imageWrapper = scopeEl.querySelector('.productView-image-wrapper'),
                    videoModal = document.querySelector('[data-popup-video]'),
                    sliderNav = scopeEl.querySelector('.productView-nav');
                if (!imageWrapper) return;
                
                let offsetTop = imageWrapper.getBoundingClientRect().top + window.scrollY + imageWrapper.offsetHeight;

                if (productVideoLen) {
                    $body.classList.add('has-product-video');
                }

                window.addEventListener('scroll', (event) => {
                    const targetCur = event.currentTarget || window,
                        currentSlide = sliderNav ? sliderNav.querySelector('.swiper-slide-active, .slick-current') : null,
                        thisVideo = currentSlide ? currentSlide.querySelector('.productView-video') : null;
                    if (!thisVideo) return;
                    
                    const videoType = thisVideo.dataset.type,
                        videoUrl = thisVideo.dataset.videoUrl;

                    if (videoUrl != undefined) {
                        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        if (scrollTop > offsetTop) {
                            if (!videoModal || !videoModal.classList.contains('is-show')) {
                                const activeSlide = sliderNav ? sliderNav.querySelector('.swiper-slide-active, .slick-slide.slick-active') : null;
                                const player = activeSlide ? activeSlide.dataset.youtubePlayer : null;
                                if (!player) return;
                                
                                const dataTime = parseInt(player.getCurrentTime ? player.getCurrentTime() : 0),
                                    videoContent = `<div class="fluid-width-video-wrapper" style="padding-top: 56.24999999999999%">
                                                    ${videoType == 'youtube' ?
                                            `<iframe
                                                            id="player"
                                                            type="text/html"
                                                            width="100%"
                                                            frameborder="0"
                                                            webkitAllowFullScreen
                                                            mozallowfullscreen
                                                            allowFullScreen
                                                            src="https://www.youtube.com/embed/${videoUrl}?autoplay=1&mute=1&start=${dataTime}">
                                                        </iframe>`
                                            :
                                            `<iframe 
                                                            src="https://player.vimeo.com/video/${videoUrl}?autoplay=1&mute=1" 
                                                            class="js-vimeo" 
                                                            allow="autoplay; 
                                                            encrypted-media" 
                                                            webkitallowfullscreen 
                                                            mozallowfullscreen 
                                                            allowfullscreen">
                                                        </iframe>`
                                        }
                                                </div>`;
                                if (videoModal) {
                                    videoModal.classList.add('is-show');
                                    const popupContent = videoModal.querySelector('.halo-popup-content');
                                    if (popupContent) popupContent.innerHTML = videoContent;
                                }
                                $body.classList.add('video-show', 'product-video-show');
                                if (player.pauseVideo) player.pauseVideo();
                            }
                        } else {
                            const activeSlide = sliderNav ? sliderNav.querySelector('.swiper-slide-active, .slick-slide.slick-active') : null;
                            const player = activeSlide ? activeSlide.dataset.youtubePlayer : null;
                            if (player && videoModal) {
                                videoModal.classList.remove('is-show');
                                const popupContent = videoModal.querySelector('.halo-popup-content');
                                if (popupContent) popupContent.innerHTML = '';
                                $body.classList.remove('video-show', 'product-video-show');
                                if (player.playVideo) player.playVideo();
                            }
                        }
                    }
                });
            }
        },

        initVariantImageGroup: function ($scope, enable = false) {
            if (enable) {
                // Convert $scope from jQuery to DOM element if needed
                const scopeEl = $scope instanceof Element ? $scope : ($scope && $scope[0] ? $scope[0] : $scope);
                if (!scopeEl) return;
                
                var inputChecked = scopeEl.querySelector('[data-filter]:checked'),
                    sliderFor = scopeEl.querySelector('.productView-for'),
                    sliderNav = scopeEl.querySelector('.productView-nav'),
                    productOption = scopeEl.querySelector('.productView-product .productView-options'),
                    metafields = inputChecked ? (inputChecked.dataset.metafieldsVig ? (function() {
                        try {
                            return JSON.parse(inputChecked.dataset.metafieldsVig);
                        } catch(e) {
                            return null;
                        }
                    })() : null) : null,
                    pageLayout,
                    sliderNavHTML = sliderNav ? sliderNav.innerHTML : '';

                const sliderNavEl = sliderNav instanceof Element ? sliderNav : (sliderNav && sliderNav[0] ? sliderNav[0] : sliderNav);
                if (!sliderNavEl) return;

                switch (true) {
                    case sliderNavEl.classList.contains('productView-nav-gallery'):
                        pageLayout = 'gallery';
                        break;
                    case (sliderNavEl.closest('.product-full-width') !== null || sliderNavEl.closest('.product-full-width-2') !== null):
                        pageLayout = 'full-width';
                        break;
                    default:
                        pageLayout = 'default';
                }

                const unFilter = () => {
                    // Use Swiper if available, otherwise fallback to Slick
                    const sliderForEl = sliderFor instanceof Element ? sliderFor : (sliderFor && sliderFor[0] ? sliderFor[0] : sliderFor);
                    if (sliderForEl && sliderForEl.swiperInstance) {
                        // Swiper: show all slides
                        const swiper = sliderForEl.swiperInstance;
                        swiper.slides.forEach(slide => {
                            slide.style.display = '';
                        });
                        swiper.update();
                    }
                    
                    if (pageLayout == 'full-width' && window.innerWidth > 767) return;
                    const sliderNavEl = sliderNav instanceof Element ? sliderNav : (sliderNav && sliderNav[0] ? sliderNav[0] : sliderNav);
                    if (sliderNavEl && sliderNavEl.classList.contains('slick-filter')) {
                        const slickCounter = sliderNavEl.querySelector('.slick-counter');
                        if (slickCounter) slickCounter.remove();
                    }
                    if (sliderNavEl && sliderNavEl.swiperInstance) {
                        // Swiper: show all slides
                        const swiper = sliderNavEl.swiperInstance;
                        swiper.slides.forEach(slide => {
                            slide.style.display = '';
                        });
                        swiper.update();
                    }
                    if (sliderNavEl) sliderNavEl.classList.remove('slick-filter');
                }

                const filter = (list) => {
                    switch (pageLayout) {
                        case 'gallery':
                            // Convert to vanilla JS
                            const sliderNavEl = sliderNav instanceof Element ? sliderNav : (sliderNav && sliderNav[0] ? sliderNav[0] : sliderNav);
                            if (sliderNavEl) {
                                // Destroy existing Swiper if present
                                if (sliderNavEl.swiperInstance) {
                                    sliderNavEl.swiperInstance.destroy(true, true);
                                }
                                // Slick removed - no longer needed
                                
                                sliderNavEl.innerHTML = sliderNavHTML;
                                
                                // Filter images
                                const productViewImages = sliderNavEl.querySelectorAll('.productView-image');
                                productViewImages.forEach(function (imgEl) {
                                    const matchesList = list.split(',').some(selector => {
                                        try {
                                            return imgEl.matches(selector.trim());
                                        } catch(e) {
                                            return false;
                                        }
                                    });
                                    if (!matchesList) {
                                        imgEl.remove();
                                    }
                                });
                            }

                            const navArrowsDesk = sliderNavEl ? (sliderNavEl.dataset.arrowsDesk === 'true') : false,
                                navArrowsMobi = sliderNavEl ? (sliderNavEl.dataset.arrowsMobi === 'true') : false,
                                length = sliderNavEl ? parseInt(sliderNavEl.dataset.mediaCount || 1) : 1,
                                oneItems = sliderNavEl ? (sliderNavEl.dataset.itemMobi === 'true') : false,
                                show = 2,
                                rows = 2;

                            if (length == 1) {
                                show = 1;
                                rows = 1;
                            }

                            if (length == 2) {
                                show = 2;
                                rows = 1;
                            }

                            if (oneItems && window.innerWidth < 551) {
                                show = 1;
                                rows = 1;
                            }

                            // Try to use Swiper module if available
                            if (typeof window.initProductImageGallery === 'function' && sliderNavEl) {
                                const result = window.initProductImageGallery(scopeEl);
                                if (result && result.nav) {
                                    // Swiper initialized successfully
                                }
                            }
                            // productCustomCursor removed - cursor is now handled by CSS
                            break;
                        case 'full-width':
                            if (window.innerWidth > 767) {
                                let dataIndex = 1, checkList = 0;

                                const sliderNavEl = sliderNav instanceof Element ? sliderNav : (sliderNav && sliderNav[0] ? sliderNav[0] : sliderNav);
                                if (sliderNavEl) {
                                    sliderNavEl.innerHTML = sliderNavHTML;
                                }

                                if (sliderNavHTML.length) {
                                    list.split(',').forEach(element => { if (sliderNavHTML.includes(element.replace(/\./g, ''))) checkList++ });
                                    if (!sliderNavEl) return;
                                    
                                    if (checkList == 0) {
                                        sliderNavEl.classList.remove('media-filter');
                                    } else {
                                        sliderNavEl.classList.add('media-filter');
                                        const productViewImages = sliderNavEl.querySelectorAll('.productView-image');
                                        productViewImages.forEach(function (imgEl) {
                                            const matchesList = list.split(',').some(selector => {
                                                try {
                                                    return imgEl.matches(selector.trim());
                                                } catch(e) {
                                                    return false;
                                                }
                                            });
                                            if (!matchesList) {
                                                imgEl.remove();
                                            } else {
                                                imgEl.setAttribute('data-index', dataIndex);
                                                const img = imgEl.querySelector('img');
                                                if (img) img.setAttribute('data-index', dataIndex);
                                                dataIndex++;
                                            }
                                        });
                                    }
                                }

                                const cursorWrapper = document.querySelector('.cursor-wrapper');
                                const haloProductView = document.querySelector('.halo-productView');
                                const halo = getHalo();
                                if (cursorWrapper && haloProductView) {
                                    const counterTotal = cursorWrapper.querySelector('.counter-total');
                                    const productViewImages = sliderNavEl ? sliderNavEl.querySelectorAll('.productView-image') : [];
                                    if (counterTotal) counterTotal.textContent = productViewImages.length;
                                    // productCustomCursor removed - cursor is now handled by CSS
                                }

                                break;
                            }
                            break;
                        default: {
                            const sliderNavEl = sliderNav instanceof Element ? sliderNav : (sliderNav && sliderNav[0] ? sliderNav[0] : sliderNav);
                            if (sliderNavEl) {
                                // Try Swiper first
                                if (sliderNavEl.swiperInstance) {
                                    // Swiper: filter slides
                                    const swiper = sliderNavEl.swiperInstance;
                                    swiper.slides.forEach(slide => {
                                        const matchesList = list.split(',').some(selector => {
                                            try {
                                                return slide.matches(selector.trim());
                                            } catch(e) {
                                                return false;
                                            }
                                        });
                                        slide.style.display = matchesList ? '' : 'none';
                                    });
                                    swiper.update();
                                    sliderNavEl.classList.add('swiper-filter');
                                }
                                sliderNavEl.classList.add('slick-filter');
                            }
                            const sliderForEl = sliderFor instanceof Element ? sliderFor : (sliderFor && sliderFor[0] ? sliderFor[0] : sliderFor);
                            if (sliderForEl) {
                                if (sliderForEl.swiperInstance) {
                                    // Swiper: filter slides
                                    const swiper = sliderForEl.swiperInstance;
                                    swiper.slides.forEach(slide => {
                                        const matchesList = list.split(',').some(selector => {
                                            try {
                                                return slide.matches(selector.trim());
                                            } catch(e) {
                                                return false;
                                            }
                                        });
                                        slide.style.display = matchesList ? '' : 'none';
                                    });
                                    swiper.update();
                                }
                            }
                        }
                    }
                }

                const setImageForMetafields = (list, unfilter) => {
                    let array = list.split(','),
                        slidesToKeep = [];

                    array.forEach(element => {
                        slidesToKeep.push(`.filter-${element.toLowerCase().replace(/[^A-Z0-9]/ig, '-')}`);
                    });

                    if (unfilter) unFilter();
                    filter(slidesToKeep.join(','));
                }

                const setImage = (className, input) => {
                    const productOptionEl = productOption instanceof Element ? productOption : (productOption && productOption[0] ? productOption[0] : productOption);
                    const inputEl = input instanceof Element ? input : (input && input[0] ? input[0] : input);
                    if (!productOptionEl || !inputEl) return;
                    
                    if (productOptionEl.dataset.lang != productOptionEl.dataset.defaultLang && inputEl.dataset.valueDefaultLang) {
                        className = `.filter-${inputEl.dataset.valueDefaultLang}`;
                    }
                    unFilter();
                    if (className !== undefined) {
                        const sliderNavEl = sliderNav instanceof Element ? sliderNav : (sliderNav && sliderNav[0] ? sliderNav[0] : sliderNav);
                        const sliderForEl = sliderFor instanceof Element ? sliderFor : (sliderFor && sliderFor[0] ? sliderFor[0] : sliderFor);
                        const hasNavMatch = sliderNavEl ? sliderNavEl.querySelector(className) !== null : false;
                        const hasForMatch = sliderForEl ? sliderForEl.querySelector(className) !== null : false;
                        if (hasNavMatch || hasForMatch || pageLayout == 'full-width') filter(className);
                    }
                }

                if (inputChecked) {
                    let className = inputChecked.dataset.filter || inputChecked.getAttribute('data-filter');
                    metafields && metafields.length ? setImageForMetafields(metafields, false) : setImage(className, inputChecked);
                }

                document.addEventListener('change', function(event) {
                    const filterInput = event.target.closest('input[data-filter]');
                    if (!filterInput) return;
                    
                    let className = filterInput.getAttribute('data-filter');
                    let thisMetafields = filterInput.getAttribute('data-metafields-vig');
                    if (thisMetafields) {
                        try {
                            thisMetafields = JSON.parse(thisMetafields);
                        } catch(e) {
                            thisMetafields = null;
                        }
                    }
                    thisMetafields && thisMetafields.length ? setImageForMetafields(thisMetafields, true) : setImage(className, filterInput);
                });
            }
        },

        initYoutubeCarousel: function (slider) {
            // Use Swiper module if available
            if (typeof window.initYoutubeCarouselSwiper === 'function') {
                // Convert jQuery collection to array if needed
                const sliderArray = slider instanceof NodeList ? Array.from(slider) : 
                                   (slider instanceof Element ? [slider] : 
                                   (slider && slider.length ? Array.from(slider) : [slider]));
                
                sliderArray.forEach(slick => {
                    if (slick && slick.querySelector && slick.querySelector('[data-youtube]')) {
                        window.initYoutubeCarouselSwiper(slick);
                    }
                });
                return;
            }
        },

        productSizeChart: function ($scope) {
            const scopeEl = $scope instanceof Element ? $scope : ($scope && $scope[0] ? $scope[0] : $scope);
            if (!scopeEl) return;
            
            window.sizeChart = function () {
                var sizeChartBtn = scopeEl.querySelector('[data-open-size-chart-popup]');
                if (!sizeChartBtn) return;

                sizeChartBtn.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    document.body.classList.add('size-chart-show');
                    if (document.body.classList.contains('quick-view-show')) {
                        const popupContent = document.querySelector('.halo-popup-content .halo-size-chart-popup');
                        if (popupContent) popupContent.classList.add('is-show');
                    }
                    else {
                        const mainContent = document.querySelector('#MainContent .halo-size-chart-popup');
                        if (mainContent) mainContent.classList.add('is-show');
                    }
                });

                document.addEventListener('click', (event) => {
                    const closeBtn = event.target.closest('[data-close-size-chart-popup]');
                    if (closeBtn) {
                        $body.classList.remove('size-chart-show');
                        document.querySelectorAll('.halo-size-chart-popup').forEach(popup => {
                            popup.classList.remove('is-show');
                        });
                    }
                });

                document.addEventListener('click', (event) => {
                    if ($body.classList.contains('size-chart-show')) {
                        const openBtn = event.target.closest('[data-open-size-chart-popup]');
                        const popup = event.target.closest('[data-size-chart-popup]');
                        if (!openBtn && !popup) {
                            $body.classList.remove('size-chart-show');
                        }
                    }
                });
            };

            var quickViewShow = document.body.classList.contains('quick-view-show'),
                productSizeChart = document.querySelectorAll('.halo-productView .productView-sizeChart').length;

            if (document.body.classList.contains('template-product')) {
                if (!quickViewShow && productSizeChart) {
                    window.sizeChart();
                } else if (quickViewShow && productSizeChart === 0) {
                    window.sizeChart();
                }
            } else {
                window.sizeChart();
            }
        },

        productLastSoldOut: function ($scope) {
            const scopeEl = $scope instanceof Element ? $scope : ($scope && $scope[0] ? $scope[0] : $scope);
            if (!scopeEl) return;
            
            var wrapper = scopeEl.querySelector('[data-sold-out-product]');
            if (!wrapper) return;

            var numbersProductList = wrapper.dataset.item ? wrapper.dataset.item.toString().split(',') : [],
                    numbersProductItem = Math.floor(Math.random() * numbersProductList.length),
                numbersHoursList = wrapper.dataset.hours ? wrapper.dataset.hours.toString().split(',') : [],
                    numbersHoursItem = Math.floor(Math.random() * numbersHoursList.length);

            const numberEl = wrapper.querySelector('[data-sold-out-number]');
            const hoursEl = wrapper.querySelector('[data-sold-out-hours]');
            if (numberEl && numbersProductList[numbersProductItem]) {
                numberEl.textContent = numbersProductList[numbersProductItem];
            }
            if (hoursEl && numbersHoursList[numbersHoursItem]) {
                hoursEl.textContent = numbersHoursList[numbersHoursItem];
            }
            wrapper.style.display = '';
        },

        productCustomerViewing: function ($scope) {
            const scopeEl = $scope instanceof Element ? $scope : ($scope && $scope[0] ? $scope[0] : $scope);
            if (!scopeEl) return;
            
            var wrapper = scopeEl.querySelector('[data-customer-view]');
            if (!wrapper) return;

            var numbersViewer = wrapper.dataset.customerView,
                numbersViewerList = numbersViewer ? JSON.parse('[' + numbersViewer + ']') : [],
                numbersViewerTime = wrapper.dataset.customerViewTime,
                timeViewer = parseInt(numbersViewerTime || 0) * 1000;

            if (numbersViewerList.length > 0 && timeViewer > 0) {
                setInterval(function () {
                    var numbersViewerItem = (Math.floor(Math.random() * numbersViewerList.length));
                    const textEl = wrapper.querySelector('.text');
                    if (textEl) {
                        textEl.textContent = window.customer_view.text.replace('[number]', numbersViewerList[numbersViewerItem]);
                    }
                }, timeViewer);
            }
        },

        productCountdown: function ($scope) {
            const scopeEl = $scope instanceof Element ? $scope : ($scope && $scope[0] ? $scope[0] : $scope);
            if (!scopeEl) return;
            
            var wrapper = scopeEl.querySelector('[data-countdown-id]');
            if (!wrapper) return;
            
            var countDown = wrapper.dataset.countdown,
                countDownDate = new Date(countDown).getTime(),
                countDownText = window.countdown.text;

            if (isNaN(countDownDate)) return;

                var countdownfunction = setInterval(function () {
                    var now = new Date().getTime(),
                        distance = countDownDate - now;

                    if (distance < 0) {
                        clearInterval(countdownfunction);
                        wrapper.remove();
                    } else {
                        var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                            minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                            seconds = Math.floor((distance % (1000 * 60)) / 1000),
                            strCountDown;

                    const isStyle234 = wrapper.classList.contains('style-2') || 
                                      wrapper.classList.contains('style-3') || 
                                      wrapper.classList.contains('style-4');
                    
                    if (isStyle234) {
                            strCountDown = '<span class="text"><span>' + countDownText + '</span></span><span class="num">' + days + '<span>' + window.countdown.day_2 + '</span></span>\
                                <span class="num">'+ hours + '<span>' + window.countdown.hour_2 + '</span></span>\
                                <span class="num">'+ minutes + '<span>' + window.countdown.min_2 + '</span></span>\
                                <span class="num">'+ seconds + '<span>' + window.countdown.sec_2 + '</span></span>';
                        }
                        else {
                            strCountDown = '<span class="text"><span>' + countDownText + '</span></span><span class="num">' + days + '<span>' + window.countdown.day + '</span></span>\
                                <span class="num">'+ hours + '<span>' + window.countdown.hour + '</span></span>\
                                <span class="num">'+ minutes + '<span>' + window.countdown.min + '</span></span>\
                                <span class="num">'+ seconds + '<span>' + window.countdown.sec + '</span></span>';
                        }

                    wrapper.innerHTML = strCountDown;
                    wrapper.classList.add('show');
                    }
                }, 1000);
        }

        // productCustomCursor function removed - cursor is now handled by CSS
    };
    
    // Attach to window.halo
    if (!window.halo) {
        window.halo = {};
    }
    
    // Attach all product view functions to halo
    Object.assign(window.halo, productView);
    
    // Auto-initialize on product pages
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            const productViewEl = document.querySelector('.halo-productView');
            if (productViewEl) {
                productView.initProductView(productViewEl);
            }
        });
    } else {
        const productViewEl = document.querySelector('.halo-productView');
        if (productViewEl) {
            productView.initProductView(productViewEl);
        }
    }
})();

